import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { Urls } from "../../../utils/constant";
import { useApi } from "../apiCall/useApi";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
// import { setHelpList } from "../../reducers/Help/help.reducer";
import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";
import { setHelpList } from "../../reducers/Help/help.reducer";

const COLUMN_LIST = [
  {
    field: "sr_no",
    headerName: "sr. no.",
    // flex: 1,
    // minWidth: "50",
  },
  {
    field: "title",
    headerName: "Title",
    flex: 1,
  },
  {
    field: "sub_title",
    headerName: "Sub Title",
    flex: 1,
  },
  {
    field: "detail",
    headerName: "Detail",
    flex: 2,
  },
  {
    field: "status_val",
    headerName: "Status",
    flex: 1,
  },
];

const StatusList = [
  { id: 1, label: "active" },
  { id: 2, label: "In-Active" },
];

export default function useHelp() {
  const dispatch = useDispatch();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [detail, setDetails] = useState("");
  const [status, setStatus] = useState(1);

  const fetchHelpList = useCallback(
    async ({ current_page = 1, row_count }) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());
        const StatusVal = status === "All" ? 0 : status;
        const { data } = await apiPost({
          url: Urls.helpGet(),
          data: {
            id: "",
            title: title,
            sub_title: subTitle,
            detail: detail,
            status: StatusVal,
            page_size: row_count,
            current_page: current_page,
          },
        });
        // setting list to reducer
        dispatch(setHelpList(data));
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
      }
    },
    [loading, status, title, subTitle, detail]
  );

  const handleTitleChange = useCallback((e) => {
    setTitle(e.target.value);
  }, []);
  const handleSubTitleChange = useCallback((e) => {
    setSubTitle(e.target.value);
  }, []);
  const handleDetailChange = useCallback((e) => {
    setDetails(e.target.value);
  }, []);

  const handleStatusChange = useCallback((e) => {
    setStatus(e.target.value);
  }, []);

  return {
    gridHeaders: COLUMN_LIST,
    loading,
    loader,
    status,
    StatusList,
    title,
    subTitle,
    detail,
    handleTitleChange,
    handleDetailChange,
    handleSubTitleChange,
    handleStatusChange,
    fetchHelpList,
  };
}
